export const selectFactoryRentTypes = (state) => state.factoryRentTypes.rentTypes;

export const selectFactoryRentTypesLoading = (state) => state.factoryRentTypes.loading;
export const selectFactoryRentTypesError = (state) => state.factoryRentTypes.error;